<template>
  <div class="fff" ref="fff">
    <div>
      <div class="tab">
        <div
          @click="setIsshow(1)"
          :class="isshow == 1 ? 'tab_li mr' : 'tab_li'"
        >
          {{ $t("geoFenc.title") }}
          <div></div>
        </div>
        <div
          @click="setIsshow(0)"
          :class="isshow == 0 ? 'tab_li mr' : 'tab_li'"
        >
          {{ $t("geoFenc.blocked") }}
          <div></div>
        </div>
      </div>
      <div class="Rules" v-show="isshow == 0" :style="{ 'min-height': height }">
        <div class="add_l">
          <div class="g_list" v-for="(val, key) in list" :key="key">
            <img @click="showVisible(val.id)" src="@/assets/img/del.png" />
            <img @click="getPopup(val, isshow)" src="@/assets/img/xie.png" />
            {{ val.latitude }},{{ val.longitude }}
          </div>
          <div @click="getPopup({ id: '' }, isshow)" class="loginButton">
            {{ $t("geoFenc.add") }}
          </div>
        </div>
        <div class="add_r">
          <div class="title">{{ $t("geoFenc.map") }}</div>
          <div class="google-map" ref="map"></div>
        </div>
      </div>
      <div class="Rules" v-show="isshow == 1" :style="{ 'min-height': height }">
        <div class="add_l">
          <div class="g_list" v-for="(val, key) in list2" :key="key">
            <img @click="showVisible(val.id)" src="@/assets/img/del.png" />
            <img @click="getPopup(val, 1)" src="@/assets/img/xie.png" />
            {{ val.latitude }},{{ val.longitude }}
          </div>
          <div @click="getPopup({ id: '' }, 1)" class="loginButton">
            {{ $t("geoFenc.add") }}
          </div>
        </div>
        <div class="add_r">
          <div class="title">{{ $t("geoFenc.map") }}</div>
          <div class="google-map" ref="map1"></div>
        </div>
      </div>
      <div class="Popup syy" v-if="type > 0">
        <div class="Popups_w"></div>
        <div :class="'Popups Popups1'">
          <img @click="type = 0" src="@/assets/img/x.png" class="close" />
          <div>
            <div class="Popups_title">{{ $t("geoFenc.subscription") }}</div>
            <div class="Popups_con">{{ $t("geoFenc.keywords") }}</div>
            <input
              v-model="upKey.Keywords"
              type="text"
              placeholder="Keywords"
              class="other"
              style="margin-bottom: 10px"
            />
            <div class="Popups_con w50">{{ $t("geoFenc.latitude") }}</div>
            <div class="Popups_con w50 l4">{{ $t("geoFenc.Longitude") }}</div>
            <input
              v-model="upKey.lat"
              type="text"
              placeholder="latitude"
              class="other w50"
              style="margin-bottom: 10px"
            />
            <input
              v-model="upKey.lng"
              type="text"
              placeholder="Longitude"
              class="other w50 l4"
              style="margin-bottom: 10px"
            />
            <div class="Popups_con">{{ $t("geoFenc.radius") }}</div>
            <input
              v-model="upKey.radus"
              type="text"
              placeholder="radius"
              class="other"
              style="margin-bottom: 10px"
            />
            <!-- <div style=" overflow: hidden;">
            <div class="Popups_con w20">type:</div>
            <div class="Popups_con w50">
              <template>
                <el-radio v-model="upKey.type" label=0>Agree</el-radio>
                <el-radio v-model="upKey.type" label=1>Disagree</el-radio>
              </template>
            </div>
          </div> -->
            <div @click="addgps" v-if="!upKey.gps_id" class="loginButton">
              {{ $t("geoFenc.add") }}
            </div>
            <div @click="getgps" v-if="upKey.gps_id" class="loginButton">
              {{ $t("geoFenc.editor") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="Notification" :visible.sync="dialogVisible" width="30%">
      <span>{{ $t("geoFenc.are") }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{
          $t("geoFenc.cancel")
        }}</el-button>
        <el-button type="primary" @click="delgps(locationId)">{{
          $t("geoFenc.ok")
        }}</el-button>
      </span>
    </el-dialog>
    <selection ref="selection" @change="selectionAdd"></selection>
  </div>
</template>

<script>
// import {geogpsDelete, geogpsGetGps, GeogpsInsertGps} from '@/api/user'
import selection from "./selection";
import {
  geogpsGetGps,
  GeogpsInsertGps,
  geogpsEdit,
  geogpsDelete,
  getMapKeys,
} from "@/api/user";
export default {
  name: "HelloWorld",
  components: {
    selection,
  },
  data() {
    return {
      dialogVisible: false,
      key: {
        equipment_id: localStorage.getItem("systemId"),
        page: 1,
        limit: 9999,
        type: 0,
      },
      key2: {
        equipment_id: localStorage.getItem("systemId"),
        page: 1,
        limit: 9999,
        type: 1,
      },
      list: [],
      list2: [],
      isshow: 1,
      msg: "",
      type: 0,
      upKey: {
        equipment_id: localStorage.getItem("systemId"),
        gps_id: "",
        Keywords: "",
        lat: "",
        lng: "",
        radus: "",
      },
      map: null,
      lat: 40.772072448457735,
      lng: -73.99482299312687,
      markers: [],
      infowindows: [],
      selectInfo: null,
      timer: null,
      radus: 2000,
      bodyWidth: document.body.clientWidth || window.innerWidth,
      bodyHeight: document.body.clientHeight || window.innerHeight,
      show: false,
      locationId: null,
      height: 0,
    };
  },
  mounted() {
    this.getlist();
    this.$nextTick(() => {
      this.height = `calc(${this.$refs.fff.clientHeight}px - 61px)`;
    });
  },
  methods: {
    showVisible(id) {
      this.locationId = id;
      this.dialogVisible = true;
    },
    setIsshow(e) {
      this.isshow = e;
      setTimeout(() => {
        console.log(">>>>>", this.list[0], this.list2[0]);
        if (this.isshow === 1) {
          this.initMap(this.list2[0], "map1");
        } else {
          this.initMap(this.list[0], "map");
        }
      }, 100);
    },
    selectionAdd(e) {
      let obj = {
        equipment_id: localStorage.getItem("systemId"),
        type: this.upKey.type,
        gps_id: this.upKey.id,
        ...this.upKey,
        ...e,
      };
      if (obj.id) {
        geogpsEdit(obj).then((adj) => {
          this.type = 0;
          this.getlist();
        });
      } else {
        GeogpsInsertGps(obj).then((adj) => {
          this.type = 0;
          this.getlist();
        });
      }
    },

    getlist() {
      geogpsGetGps(this.key).then((adj) => {
        console.log(adj);
        this.list = adj.data.list;
        if (this.isshow !== 1) {
          this.initMap(this.list[0], "map");
        }
      });
      geogpsGetGps(this.key2).then((adj) => {
        console.log(adj);
        this.list2 = adj.data.list;
        if (this.isshow === 1) {
          this.initMap(this.list2[0], "map1");
        }
      });
    },
    getPopup(obj, a) {
      if (obj.id) {
        this.$refs.selection.showEdit(obj);
      } else {
        let lastData = null;
        if (this.isshow === 0) {
          lastData = this.list[this.list.length - 1];
        }else{
          lastData = this.list2[this.list2.length - 1]
        }

        this.$refs.selection.showEdit({
          ...lastData,
          id: "",
        });
      }

      this.upKey = {
        ...obj,
        type: a,
      };
    },
    addgps() {
      GeogpsInsertGps(this.upKey).then((adj) => {
        this.type = 0;
        this.getlist();
      });
    },
    getgps() {
      console.log(123);
      geogpsEdit(this.upKey).then((adj) => {
        this.type = 0;
        this.getlist();
      });
    },
    delgps(a) {
      let asd = {
        equipment_id: localStorage.getItem("systemId"),
        gps_id: a,
      };
      geogpsDelete(asd).then((adj) => {
        this.getlist();
        this.dialogVisible = false;
      });
    },
    async initMap(row, key) {
      const ddd = await getMapKeys();
      this.$refs.map.innerHTML = `<div style="height: 100%;width:100%;" id="map"></div>`;
      this.$refs.map1.innerHTML = `<div style="height: 100%;width:100%;" id="map1"></div>`;
      let myIcon = L.icon({
        iconUrl: require("./../assets/img/lastMap.png"),
        iconSize: [27, 40],
        iconAnchor: [15, 32],
      });

      this.map = L.map(key, {
        center: [Number(row.latitude), Number(row.longitude)], // 地图中心
        zoom: 15, //缩放比列
        zoomControl: false, //禁用 + - 按钮
        doubleClickZoom: false, // 禁用双击放大
        attributionControl: false, // 移除右下角leaflet标识
      });
      // styles/
      L.tileLayer(
        // "https://tile.openstreetmap.org/{z}/{x}/{y}.png"
        // "https://a.tile.openstreetmap.org/{z}/{x}/{y}.png"
        `https://api.mapbox.com/styles/v1/mapbox/streets-v9/tiles/256/{z}/{x}/{y}@2x?access_token=${ddd.data.key}`,
        {
          minZoom: 5,
          maxZoom: 18,
        }
      ).addTo(this.map);

      L.marker([Number(row.latitude), Number(row.longitude)], {
        icon: myIcon,
      }).addTo(this.map);
      L.circle([Number(row.latitude), Number(row.longitude)], {
        radius: Math.sqrt(row.radus / 100) * 100,
        color: "#FF0000",
      }).addTo(this.map);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.g_list {
  width: 90%;
  margin: 0 0 0 10%;
  border-bottom: 1px solid #e1e3e6;
  line-height: 60px;
  height: 60px;
  overflow: hidden;
  font-size: 14px;
  color: #000927;
}
.g_list img {
  float: right;
  width: 24px;
  height: 24px;
  margin: 18px 25px 0 0;
}
.loginButton {
  width: 186px;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
  margin-top: 25px;
}
.fff {
  width: 97%;
  margin: 20px auto;
  background: #fff;
  border-radius: 12px;
  -webkit-box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  overflow: hidden;
  padding-bottom: 0;
}
.Rules {
  position: relative;
  display: flex;
}
.add_l {
  width: 35%;
  left: 0;
  top: 0;
  border-right: 1px solid #e1e3e6;
}
.add_r {
  width: 65%;
  float: right;
  /* border-left: 1px solid #e1e3e6; */
  height: 100%;
}
.title {
  height: 60px;
  text-indent: 7.5%;
  line-height: 60px;
  font-size: 16px;
  color: #000927;
  font-weight: 700;
}
.add_r .title {
  text-indent: 4%;
  border-bottom: 1px solid #e1e3e6;
}
.add_l_a {
  width: 85%;
  margin: 0 auto;
  border: 1px solid #e1e3e6;
  border-radius: 12px;
}
.add_l_tit {
  line-height: 30px;
  padding-top: 10px;
  font-size: 12px;
  text-indent: 6%;
}
.add_l_a input {
  display: block;
  width: 88%;
  margin: 0 auto;
  border: 1px solid #e1e3e6;
  border-radius: 12px;
  height: 34px;
  line-height: 34px;
  background: #f6f8fa;
  font-size: 12px;
  text-indent: 10px;
}
.add_l_a input.dow {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABYWlDQ1BrQ0dDb2xvclNwYWNlRGlzcGxheVAzAAAokWNgYFJJLCjIYWFgYMjNKykKcndSiIiMUmB/yMAOhLwMYgwKicnFBY4BAT5AJQwwGhV8u8bACKIv64LMOiU1tUm1XsDXYqbw1YuvRJsw1aMArpTU4mQg/QeIU5MLikoYGBhTgGzl8pICELsDyBYpAjoKyJ4DYqdD2BtA7CQI+whYTUiQM5B9A8hWSM5IBJrB+API1klCEk9HYkPtBQFul8zigpzESoUAYwKuJQOUpFaUgGjn/ILKosz0jBIFR2AopSp45iXr6SgYGRiaMzCAwhyi+nMgOCwZxc4gxJrvMzDY7v////9uhJjXfgaGjUCdXDsRYhoWDAyC3AwMJ3YWJBYlgoWYgZgpLY2B4dNyBgbeSAYG4QtAPdHFacZGYHlGHicGBtZ7//9/VmNgYJ/MwPB3wv//vxf9//93MVDzHQaGA3kAFSFl7jXH0fsAAAA4ZVhJZk1NACoAAAAIAAGHaQAEAAAAAQAAABoAAAAAAAKgAgAEAAAAAQAAADCgAwAEAAAAAQAAADAAAAAA+P9ONgAAAcBJREFUaAXtVz1LA0EQ3b2LjQFrG8u0UcRSi+v9aPQaa68IIRE0f8NGCFzhzxAshOst7eJPsAmCRYrTdV6qYxEzs7eSZrbaOWbem/e4PHLG6FEH1AF1QB1QB9QBdUAdUAfUgUAHLHeuLMvNj4V9ooFD5xx7jouPPmutc8Y8TkZXZ3T/5swmnCb0fC7snnHu6L+WB8cS27nju/uHXdScwxaw3++9EOCMA9qyZ7azvfXKxWALyLKsTjv21Fgz54KL+wgbHHmef3Fn2QIAeDMs3ujdzOlacwkEfTWwwSGYMSIBAJ6MiufE2LGEhNMLTGBzeps9YgEYvr0upuTWtAnU5g4sYIZgBAkA0UG/NyZisWP+ksAAlv+cWwcLwI+6u9HNaQHRO9tcDLPAAFbzueQeLAAkg8HlPEnNSVAyUeJgFhiShf3eVgIAFphMQYnjL4+6tQCASJMpNHHA5Z8oAgDKTSZ674MTx18edTQBAFuVTG0TBxz+iSrgr2SKkTj+8qijCgDgr8kUKXGA75/oAkCwTKYkOaePhndEbGrSC+l/HH/RtdT4CKqqqrMWciVVB9QBdUAdUAfUAXVAHVAH1IFVDvwAa1RzCH86oE4AAAAASUVORK5CYII=);
  background-size: 16px;
  background-repeat: no-repeat;
  background-position: 100%;
  background-position-x: 96%;
}
.RulesButton {
  width: 88%;
  margin: 30px auto;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}
.mytable {
  width: 92%;
}
.Detected .mytable {
  width: 95%;
}

.Popups_title {
  margin-top: 30px;
  margin-bottom: 20px;
}
.Popups {
  padding: 0 50px;
}
.Popups1 {
  width: 400px;
  height: 420px;
  margin: -210px -250px;
}
.Popups_title {
  font-size: 16px;
  color: #000927;
  font-weight: 400;
}
.Popups_con {
  font-size: 14px;
  color: grey;
  margin-top: 10px;
}
.Popups_con a {
  color: #0080ff;
}
.Popups_con.w50 {
  float: left;
  width: 48%;
  margin-bottom: 10px;
}
.Popups_con.w20 {
  float: left;
  width: 20%;
  margin-bottom: 10px;
}
.PopupsButton {
  width: 180px;
  height: 40px;
  float: left;
  line-height: 40px;
  font-size: 15px;
}
input.other {
  width: 398px;
  height: 38px;
  line-height: 38px;
  border: 1px solid #d5d7db;
  border-radius: 8px;
  background: #f6f8fa;
  font-size: 13px;
  text-indent: 10px;
  margin-bottom: 40px;
}
input.other.w50 {
  float: left;
  width: 48%;
  box-sizing: border-box;
}
.l4 {
  margin-left: 4%;
}
.google-map {
  width: 100%;
  height: 530px;
}
</style>



// WEBPACK FOOTER //
// src/components/GeoFencing.vue